import React from 'react';
import { useNavigate } from 'react-router';
import { Button, Divider, Space, Typography } from 'antd';
import { useIpWhitelist, usePendingClientIp } from '../../../../hooks/useAuth';
import { AuthLayout } from '../../components/Layout';

export const PageIPWhitelist = () => {
    const navigate = useNavigate();
    const clientIp = usePendingClientIp();
    const whitelist = useIpWhitelist();

    return (
        <AuthLayout
            error={whitelist.error}
            heading='New IP detected'
            subheading='This IP is not on your allow-list yet. Add it only if you trust this network.'
        >
            <div>
                Looks like you have a new IP address which is not attached to your user profile. Do you want to add it
                to the list of allowed IP addresses?
            </div>
            <Divider />
            <Typography.Title style={{ textAlign: 'center' }} level={3}>
                {clientIp ? `IP: ${clientIp}` : 'Detecting your IP…'}
            </Typography.Title>
            <Divider />
            <Space direction='vertical' size={8} style={{ width: '100%' }}>
                <Button
                    block
                    onClick={() => whitelist.mutate(clientIp)}
                    size='large'
                    type='primary'
                    loading={whitelist.isPending}
                    disabled={!clientIp}
                >
                    Trust this place, add my IP
                </Button>
                <Button block onClick={() => navigate('/')} size='large'>
                    No, I don&apos;t trust this place
                </Button>
            </Space>
        </AuthLayout>
    );
};
